const styles = {
  wrapper: 'flex flex-wrap',
  button: 'whitespace-nowrap',
};

export default styles;
